import { QuoteForm } from '@/components/forms/QuoteForm';
import { Seo, breadcrumbJsonLd, localBusinessJsonLd } from '@/lib/seo';
import { company } from '@/data/company';
import { Phone, Mail, MapPin } from '@/components/ui/Icons';

export default function Contact() {
  return (
    <>
      <Seo
        title={`Contact Us | Free Quotes Across London, Essex & Suffolk`}
        description={`Contact ${company.legalName} for a free, no-obligation quote. Roofing, driveways, landscaping, damp proofing and spray foam removal across ${company.serviceCoverage}. Call ${company.phone} - we reply within one working day.`}
        path="/contact"
        keywords="contact Bliss Building Contractors, free building quote Essex, roofing quote London Essex Suffolk, driveway quote Essex, builder enquiry Essex"
        jsonLd={[
          localBusinessJsonLd(),
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Contact', path: '/contact' },
          ]),
        ]}
      />

      <section className="bg-navy-900 pt-16 lg:pt-20">
        <div className="container-page py-16 text-paper-0 sm:py-20">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-300">
            Contact
          </p>
          <h1 className="mt-2 font-display text-4xl font-bold sm:text-5xl">
            Get your free quote today
          </h1>
          <p className="mt-4 max-w-2xl text-paper-0/85">
            Contact us for reliable, affordable contracting services you can trust across
            {' '}{company.serviceCoverage}. We aim to reply to every enquiry within one
            working day. For urgent roofing emergencies, call {company.phone} 24/7.
          </p>
        </div>
      </section>

      <section className="container-page py-16 sm:py-20">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.2fr]">
          <div className="space-y-6">
            <div className="rounded-lg border border-paper-100 bg-paper-50 p-6">
              <h2 className="font-display text-xl font-semibold text-navy-900">Get in touch</h2>
              <ul className="mt-4 space-y-4 text-ink-700">
                <li>
                  <a href={`tel:${company.phoneTel}`} className="flex items-start gap-3 hover:text-navy-700">
                    <Phone className="mt-0.5 h-5 w-5 text-gold-500" />
                    <span>
                      <span className="block text-xs uppercase tracking-wider text-ink-700/70">Phone</span>
                      <span className="text-lg font-semibold text-navy-900">{company.phone}</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href={`mailto:${company.email}`} className="flex items-start gap-3 break-all hover:text-navy-700">
                    <Mail className="mt-0.5 h-5 w-5 text-gold-500" />
                    <span>
                      <span className="block text-xs uppercase tracking-wider text-ink-700/70">Email</span>
                      <span className="font-medium text-navy-900">{company.email}</span>
                    </span>
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="mt-0.5 h-5 w-5 text-gold-500" />
                  <span>
                    <span className="block text-xs uppercase tracking-wider text-ink-700/70">Coverage</span>
                    <span className="font-medium text-navy-900">{company.serviceCoverage}</span>
                    <span className="block text-sm">Hub: {company.hub}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div className="rounded-lg border border-paper-100 bg-paper-0 p-6">
              <h2 className="font-display text-xl font-semibold text-navy-900">Hours</h2>
              <p className="mt-2 text-ink-700">{company.hours}</p>
            </div>
          </div>

          <QuoteForm />
        </div>
      </section>
    </>
  );
}
